define.alias("shared/components/shared/plan-recommendation/steps/goal", "settings/components/shared/plan-recommendation/steps/goal");